// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-boqav{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-bohdu{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bfllz{grid-column:span 6}.assets-scss-gridstyleGrid-col3-xlrjt{grid-column:span 3}.assets-scss-gridstyleGrid-col4-heoep{grid-column:span 4}.assets-scss-gridstyleGrid-col9-ficdp{grid-column:span 9}.assets-scss-gridstyleGrid-col12-oqmnb{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-oqpjo{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-boqav",
	"grid": "assets-scss-gridstyleGrid-grid-bohdu",
	"col6": "assets-scss-gridstyleGrid-col6-bfllz",
	"col3": "assets-scss-gridstyleGrid-col3-xlrjt",
	"col4": "assets-scss-gridstyleGrid-col4-heoep",
	"col9": "assets-scss-gridstyleGrid-col9-ficdp",
	"col12": "assets-scss-gridstyleGrid-col12-oqmnb",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-oqpjo"
};
module.exports = ___CSS_LOADER_EXPORT___;
